export class ContentRow {
    constructor(
        public REQUIREMENT_SUBJECT_DESC: string,
        public REQUIREMENT_NUMBER: string,
        public REQUIREMENT_DESC: string,
        public REQUIREMENT_SOURCE_DESC: string,
        public REQUIREMENT_REMARKS: string
    ) {
    }
    
}


// WEBPACK FOOTER //
// ./src/app/content-row.ts